import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, BarChart3Icon, LightbulbIcon, SlidersHorizontalIcon } from 'lucide-react';
export function IntroSlide({
  onStart,
  onSkip
}: {
  onStart: () => void;
  onSkip: () => void;
}) {
  return <div className="flex flex-col h-full px-6 py-12 relative z-10 bg-[#0B1623] justify-center" data-id="element-94">
      {/* Lab background with gradient overlay */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-95">
        <img src="https://cdn.magicpatterns.com/uploads/hF7rvjEq9antGAY8GqPuMH/Screenshot_2026-03-04_at_16.46.47.png" className="absolute inset-0 w-full h-full object-cover opacity-20" alt="" data-id="element-96" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B1623] via-[#0B1623]/80 to-transparent" data-id="element-97" />
      </div>

      {/* Skip button — top right */}
      <button onClick={onSkip} className="absolute top-6 right-6 z-20 text-xs text-slate-500 hover:text-slate-300 transition-colors" data-id="element-98">
        Skip
      </button>

      <div className="relative z-10 flex flex-col items-center text-center" data-id="element-99">
        {/* Minerva Logo */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mb-12 bg-white px-4 py-2.5 rounded-xl inline-block shadow-lg" data-id="element-100">
          <img src="https://cdn.magicpatterns.com/uploads/ifejLUcSApynCwwp5oN3Zr/Screenshot_2026-03-04_at_16.40.29.png" className="h-8 object-contain" alt="Minerva Imaging" data-id="element-101" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15,
        duration: 0.5
      }} className="text-3xl font-light text-white leading-tight mb-5" data-id="element-102">
          How are oncology development priorities shifting?
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.4
      }} className="text-base text-slate-400 leading-relaxed mb-10 max-w-xs" data-id="element-103">
          Answer 5 short questions.{'\n'}
          See how your priorities compare with peers.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.45,
        duration: 0.4
      }} className="flex flex-col items-start space-y-4 mb-14 w-full max-w-xs" data-id="element-104">
          {[{
          icon: BarChart3Icon,
          label: 'Peer benchmark'
        }, {
          icon: LightbulbIcon,
          label: 'Development insights'
        }, {
          icon: SlidersHorizontalIcon,
          label: 'Emerging priorities'
        }].map(({
          icon: Icon,
          label
        }, i) => <motion.div key={label} initial={{
          opacity: 0,
          x: -10
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.55 + i * 0.08
        }} className="flex items-center space-x-4" data-id="element-105">
              <div className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center flex-shrink-0 backdrop-blur-sm" data-id="element-106">
                <Icon className="w-5 h-5 text-[#4B9FE1]" data-id="element-107" />
              </div>
              <span className="text-sm text-slate-300" data-id="element-108">{label}</span>
            </motion.div>)}
        </motion.div>

        <motion.button initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.75,
        duration: 0.4
      }} onClick={onStart} className="w-full max-w-xs py-4 bg-[#4B9FE1] text-white rounded-xl font-medium flex items-center justify-center hover:bg-[#3A8BD0] transition-colors group focus:outline-none focus:ring-2 focus:ring-[#4B9FE1] focus:ring-offset-2 focus:ring-offset-[#0B1623]" data-id="element-109">
          Start
          <ArrowRightIcon className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-110" />
        </motion.button>
      </div>
    </div>;
}